import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_01.jpg";

const data: ReplicaItemType = {
  id: "the-daily-prophet-v2-dark-mark-sparks-panic-grade-b",
  name: "The Daily Prophet v2: Dark Mark Sparks Panic (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Daily Prophet v2",
    tertiary: "Dark Mark Sparks Panic",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
